import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.conversation.WmBranchQuoteConversation.';
  public static readonly noEntriesVisible = `${Id.prefix}noEntriesVisible`;
  public static readonly supportSubjectMustHaveValue = `${Id.prefix}supportSubjectMustHaveValue`;
  public static readonly createdBy = `${Id.prefix}createdBy`;
  public static readonly supportSubject = `${Id.prefix}supportSubject`;
  public static readonly addNote = `${Id.prefix}addNote`;
  public static readonly showAllMessages = `${Id.prefix}showAllMessages`;
  public static readonly showMoreMessages = `${Id.prefix}showMoreMessages`;
  public static readonly attachmentsOnly = `${Id.prefix}attachmentsOnly`;
  public static readonly cancelTicket = `${Id.prefix}cancelTicket`;
  public static readonly backToQuoteSupportRequest = `${Id.prefix}backToQuoteSupportRequest`;
  public static readonly issueTicket = `${Id.prefix}issueTicket`;
  public static readonly reactivateTicket = `${Id.prefix}reactivateTicket`;
  public static readonly resolveTicket = `${Id.prefix}resolveTicket`;
  public static readonly validation = `${Id.prefix}validation`;
  public static readonly changesSaved = `${Id.prefix}changesSaved`;
}

export class LangBranchQuoteConversation {
  private constructor() {}
  public static noEntriesVisible(): string {
    return interpolate(Id.noEntriesVisible);
  }
  public static changesSaved(): string {
    return interpolate(Id.changesSaved);
  }
  public static supportSubjectMustHaveValue(): string {
    return interpolate(Id.supportSubjectMustHaveValue);
  }
  public static createdBy(params: { quoteNumber: string }): string {
    return interpolate(Id.createdBy, params);
  }
  public static supportSubject(): string {
    return interpolate(Id.supportSubject);
  }
  public static addNote(): string {
    return interpolate(Id.addNote);
  }
  public static showAllMessages(params: { count: number }): string {
    return interpolate(Id.showAllMessages, params);
  }
  public static showMoreMessages(params: { count: number }): string {
    return interpolate(Id.showMoreMessages, params);
  }
  public static attachmentsOnly(): string {
    return interpolate(Id.attachmentsOnly);
  }
  public static cancelTicket(): string {
    return interpolate(Id.cancelTicket);
  }
  public static backToQuoteSupportRequest(): string {
    return interpolate(Id.backToQuoteSupportRequest);
  }
  public static issueTicket(): string {
    return interpolate(Id.issueTicket);
  }
  public static reactivateTicket(): string {
    return interpolate(Id.reactivateTicket);
  }
  public static resolveTicket(): string {
    return interpolate(Id.resolveTicket);
  }
  public static validation(): string {
    return interpolate(Id.validation);
  }
}

export class WmBranchQuoteConversationModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.noEntriesVisible,
      'There are no entries visible',
      'Message when no conversation entries are visible'
    );
    register.add(
      Id.supportSubjectMustHaveValue,
      "{{glossary 'support-subject'}} must have a value before exiting",
      'Validation error for missing support subject'
    );
    register.add(Id.createdBy, 'Created by {{quoteNumber}}', 'Label for created by with quote number');
    register.add(Id.supportSubject, "{{glossary 'support-subject'}}", 'Label for support subject');
    register.add(Id.addNote, 'Add Note', 'Button label for adding a note');
    register.add(Id.showAllMessages, 'Show all {{count}} messages', 'Link to show all messages');
    register.add(Id.showMoreMessages, 'Show {{count}} more messages', 'Link to show more messages');
    register.add(Id.attachmentsOnly, 'Attachments Only', 'Switch label for attachments only');
    register.add(Id.cancelTicket, 'Cancel Ticket', 'Button label for cancel ticket');
    register.add(
      Id.backToQuoteSupportRequest,
      "Back to {{glossary 'quote'}} {{glossary 'support-request:plural'}}",
      'Button label for back to quote support requests'
    );
    register.add(Id.issueTicket, 'Issue Ticket', 'Button label for issue ticket');
    register.add(Id.reactivateTicket, 'Reactivate Ticket', 'Button label for reactivate ticket');
    register.add(Id.resolveTicket, 'Resolve Ticket', 'Button label for resolve ticket');
    register.add(Id.validation, 'Validation', 'Validation dialog title');
    register.add(Id.changesSaved, 'Changes saved', 'Toast message when changes are saved');
  }
}
